var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    staticClass: "add-member-modal",
    attrs: {
      "id": "add-member-btn",
      "centered": true,
      "no-close-on-backdrop": "",
      "size": "sm",
      "title": "Add Member User",
      "hide-footer": true
    },
    on: {
      "show": _vm.resetForm
    }
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "addMemberContent"
  }, [_c('b-form-group', {
    staticClass: "required d-block",
    attrs: {
      "id": "input-group-1",
      "label": "Email address",
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-1",
      "type": "email",
      "placeholder": "Enter Email Address",
      "required": ""
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c('div', {
    staticClass: "validation-wrapper mb-3"
  }, [_vm.showOtpSectionEmail ? _c('div', {
    staticClass: "mem-admin-otp-validate-btn mb-3",
    attrs: {
      "id": "validate_otp"
    }
  }, [_c('a', {
    staticClass: "validate-via-otp-link validate-btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.sendOtp('email');
      }
    }
  }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL. ")])]) : _vm._e(), _c('MemberAdminOtpModal', {
    attrs: {
      "identifier": _vm.contactInfo,
      "identifierTypeText": _vm.otpType
    },
    on: {
      "save": _vm.handleVerificationResult,
      "close": _vm.closeOtpModal
    }
  }), _vm.emailMsg ? _c('div', {
    staticClass: "contacts-message-container form-group"
  }, [_c('div', {
    class: ['validate-message', _vm.emailValidationMessage.type]
  }, [_c('div', {
    class: ['message-indicator', `${_vm.emailValidationMessage.type}-indicator`]
  }), _c('span', {
    staticClass: "message-text"
  }, [_c('strong', {
    class: `${_vm.emailValidationMessage.type}-text`
  }, [_vm._v(_vm._s(_vm.emailValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.emailValidationMessage.message) + " ")])])]) : _vm._e()], 1), _c('b-form-group', {
    staticClass: "required d-block",
    attrs: {
      "id": "input-group-2",
      "label": "Phone",
      "label-for": "input-2"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-2",
      "placeholder": "Enter Phone",
      "required": ""
    },
    on: {
      "keypress": _vm.onlyAllowDigits
    },
    model: {
      value: _vm.form.phone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1), _c('div', {
    staticClass: "validation-wrapper mb-3"
  }, [_vm.showOtpSectionPhone ? _c('div', {
    staticClass: "mem-admin-otp-validate-btn mb-3",
    attrs: {
      "id": "validate_otp"
    }
  }, [_c('a', {
    staticClass: "validate-via-otp-link validate-btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.sendOtp('phone');
      }
    }
  }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE. ")])]) : _vm._e(), _vm.phoneMsg ? _c('div', {
    staticClass: "contacts-message-container form-group"
  }, [_c('div', {
    class: ['validate-message', _vm.phoneValidationMessage.type]
  }, [_c('div', {
    class: ['message-indicator', `${_vm.phoneValidationMessage.type}-indicator`]
  }), _c('span', {
    staticClass: "message-text"
  }, [_c('strong', {
    class: `${_vm.phoneValidationMessage.type}-text`
  }, [_vm._v(_vm._s(_vm.phoneValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.phoneValidationMessage.message) + " ")])])]) : _vm._e()])], 1), _c('div', {
    staticClass: "btn-wrapper d-flex justify-content-end mt-4"
  }, [_c('button', {
    staticClass: "primaryBtn",
    attrs: {
      "type": "submit",
      "disabled": !_vm.form.email || !_vm.form.phone
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.create.apply(null, arguments);
      }
    }
  }, [!_vm.isCreate ? _c('span', [_vm._v("Create")]) : _c('span', [_c('b-spinner', {
    attrs: {
      "small": "",
      "type": "grow"
    }
  }), _vm._v(" Creating... ")], 1)])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }